import {Component} from "./Component";
import {Swiper} from "swiper";


export class SwiperComponent extends Component {

    static name = "swiper";

    /**
     *
     * @returns {SwiperOptions}
     */
    get options() {
        return {
            freeMode: true,
            slidesPerView: 1.2,
            spaceBetween: 32,
            scrollbar: {
                el: ".swiper-scrollbar",
            },
            breakpoints: {
                480: {
                    slidesPerView: this.el.getAttribute("data-slides-per-view") || "auto",
                }
            }
        };
    }

    constructor(el) {
        super(el);

        /**
         * @type {Swiper}
         */
        this.swiper = new Swiper(this.el, this.options);

        console.log(this, this.options);

    }

    destroy() {
        super.destroy();

        this.swiper.destroy();
    }


}
